import { cloneElement, isValidElement, type ReactNode } from 'react'

import type { TranslateKeys, TranslateOptions } from './types'

export function defineTranslateKeys<T extends TranslateKeys>(keys: T): T {
  return keys
}

/**
 * @tolgee/react v6's rich-text tags (a paired `<strong>{title}</strong>` in `defaultValue`)
 * require the matching params entry to be a function `(chunks) => ReactElement` — v4 accepted a
 * bare self-closing element (`strong: <strong />`), which is the convention every call site in
 * this repo already uses (see e.g. VideoCardBigWithCheckbox). This bridges that gap internally so
 * none of those call sites need to change.
 */
export const toTagParams = (parameters: TranslateOptions['parameters']) => {
  if (!parameters) return parameters

  return Object.fromEntries(
    Object.entries(parameters).map(([key, value]) =>
      isValidElement(value) ? [key, (chunks: ReactNode) => cloneElement(value, undefined, chunks)] : [key, value]
    )
  )
}
